import { PROFILE_FIELD_NAMES } from './actionTypes';

export const selectProfileState = (state) => state.profile;

export const selectActiveSection = (state) => state.profile.activeSection;

export const selectProfileFields = (state) => state.profile.fields;

export const selectProfileField = (state, fieldName) => state.profile.fields[fieldName];

export const selectOriginalFields = (state) => state.profile.originalFields;

export const selectIsSaving = (state) => state.profile.isSaving;

export const selectIsLoading = (state) => state.profile.isLoading;

export const selectIsChangingPassword = (state) => state.profile.isChangingPassword;

export const selectSaveSuccess = (state) => state.profile.saveSuccess;

export const selectPasswordChangeSuccess = (state) => state.profile.passwordChangeSuccess;

export const selectSaveError = (state) => state.profile.saveError;

export const selectLoadError = (state) => state.profile.loadError;

export const selectPasswordError = (state) => state.profile.passwordError;

export const selectIsJuridic = (state) => state.profile.fields[PROFILE_FIELD_NAMES.IS_JURIDIC];

export const selectOrders = (state) => Array.isArray(state.profile?.orders) ? state.profile.orders : [];

export const selectOrdersLoading = (state) => state.profile.ordersLoading;

export const selectOrdersError = (state) => state.profile.ordersError;

export const selectOrdersPagination = (state) => state.profile.ordersPagination;

export const selectServices = (state) => state.profile.services;

export const selectServicesLoading = (state) => state.profile.servicesLoading;

export const selectServicesError = (state) => state.profile.servicesError;

export const selectServicesPagination = (state) => state.profile.servicesPagination;

export const selectDocuments = (state) => state.profile.documents;

export const selectDocumentsLoading = (state) => state.profile.documentsLoading;

export const selectDocumentsError = (state) => state.profile.documentsError;

export const selectHasChanges = (state) => {
    const { fields, originalFields } = state.profile;
    if (!originalFields) return false;

    return Object.keys(fields).some(key => fields[key] !== originalFields[key]);
};

export const selectFormErrors = (state) => {
    const fields = state.profile.fields;
    const errors = {};

    if (!fields[PROFILE_FIELD_NAMES.FIRSTNAME]) {
        errors[PROFILE_FIELD_NAMES.FIRSTNAME] = 'Обязательно для заполнения';
    } else if (!fields[PROFILE_FIELD_NAMES.FIRSTNAME].match(/^[a-zA-Zа-яА-ЯёЁ\-\s]+$/)) {
        errors[PROFILE_FIELD_NAMES.FIRSTNAME] = 'Допускаются только буквы, пробел и дефис';
    }

    if (!fields[PROFILE_FIELD_NAMES.LASTNAME]) {
        errors[PROFILE_FIELD_NAMES.LASTNAME] = 'Обязательно для заполнения';
    } else if (!fields[PROFILE_FIELD_NAMES.LASTNAME].match(/^[a-zA-Zа-яА-ЯёЁ\-\s]+$/)) {
        errors[PROFILE_FIELD_NAMES.LASTNAME] = 'Допускаются только буквы, пробел и дефис';
    }

    if (!fields[PROFILE_FIELD_NAMES.PHONE]) {
        errors[PROFILE_FIELD_NAMES.PHONE] = 'Обязательно для заполнения';
    } else if (fields[PROFILE_FIELD_NAMES.PHONE].indexOf('_') >= 0) {
        errors[PROFILE_FIELD_NAMES.PHONE] = 'Введите номер полностью';
    }

    // Email
    if (!fields[PROFILE_FIELD_NAMES.EMAIL]) {
        errors[PROFILE_FIELD_NAMES.EMAIL] = 'Обязательно для заполнения';
    } else {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(fields[PROFILE_FIELD_NAMES.EMAIL])) {
            errors[PROFILE_FIELD_NAMES.EMAIL] = 'Неверный формат email';
        }
    }

    if (!fields[PROFILE_FIELD_NAMES.DISPLAY_NAME]) {
        errors[PROFILE_FIELD_NAMES.DISPLAY_NAME] = 'Обязательно для заполнения';
    }

    if (fields[PROFILE_FIELD_NAMES.IS_JURIDIC]) {
        if (!fields[PROFILE_FIELD_NAMES.COMPANY]) {
            errors[PROFILE_FIELD_NAMES.COMPANY] = 'Обязательно для заполнения';
        }

        if (!fields[PROFILE_FIELD_NAMES.COMPANY_JOB_TITLE]) {
            errors[PROFILE_FIELD_NAMES.COMPANY_JOB_TITLE] = 'Обязательно для заполнения';
        }

        if (fields[PROFILE_FIELD_NAMES.COMPANY_INN] && !/^\d{10}$/.test(fields[PROFILE_FIELD_NAMES.COMPANY_INN])) {
            errors[PROFILE_FIELD_NAMES.COMPANY_INN] = 'ИНН должен содержать 10 цифр';
        }

        if (fields[PROFILE_FIELD_NAMES.COMPANY_KPP] && !/^\d{9}$/.test(fields[PROFILE_FIELD_NAMES.COMPANY_KPP])) {
            errors[PROFILE_FIELD_NAMES.COMPANY_KPP] = 'КПП должен содержать 9 цифр';
        }

        if (fields[PROFILE_FIELD_NAMES.COMPANY_OGRN] && !/^\d{13}$/.test(fields[PROFILE_FIELD_NAMES.COMPANY_OGRN])) {
            errors[PROFILE_FIELD_NAMES.COMPANY_OGRN] = 'ОГРН должен содержать 13 цифр';
        }
    }

    return errors;
};

export const selectHasFormErrors = (state) => {
    const errors = selectFormErrors(state);
    return Object.keys(errors).length > 0;
};

export const selectUserDisplayInfo = (state) => {
    const fields = state.profile.fields;
    return {
        displayName: fields[PROFILE_FIELD_NAMES.DISPLAY_NAME] ||
            `${fields[PROFILE_FIELD_NAMES.FIRSTNAME]} ${fields[PROFILE_FIELD_NAMES.LASTNAME]}`.trim(),
        login: fields[PROFILE_FIELD_NAMES.LOGIN],
        isJuridic: fields[PROFILE_FIELD_NAMES.IS_JURIDIC],
        company: fields[PROFILE_FIELD_NAMES.COMPANY],
    };
};

export const profileSelectors = {
    selectProfileState,
    selectActiveSection,
    selectProfileFields,
    selectProfileField,
    selectOriginalFields,
    selectIsSaving,
    selectIsLoading,
    selectIsChangingPassword,
    selectSaveSuccess,
    selectPasswordChangeSuccess,
    selectSaveError,
    selectLoadError,
    selectPasswordError,
    selectIsJuridic,
    selectOrders,
    selectOrdersLoading,
    selectOrdersError,
    selectOrdersPagination,
    selectServices,
    selectServicesLoading,
    selectServicesError,
    selectServicesPagination,
    selectDocuments,
    selectDocumentsLoading,
    selectDocumentsError,
    selectHasChanges,
    selectFormErrors,
    selectHasFormErrors,
    selectUserDisplayInfo,
};
